import Check from '@mui/icons-material/Check'
import { BrandLeftSideTreeCircle, BrandVerticalSideTreeLine } from './ClinicHomepageStyles'

// export const CADeviceUseFixingComponent = ({ CAFlowDialogOpen, setCAFlowDialogOpen }) => {
//   let roleCaConfig = localStorage.getItem('ROLE_CA_CONFIG')
//   if (roleCaConfig) {
//     roleCaConfig = JSON.parse(roleCaConfig)
//   }

//   const { assistantData } = useContext(ClinicDataContext)

//   const [selectedFlow, setSelectedFlow] = useState(
//     roleCaConfig?.FLOW_ID || ROLE_CA_FLOWS.FLOW_RECEPTION_TABLET,
//   )

//   const { registerScreen } = useAumhumScreen()

//   // Remote Screen - Brand, Location, Chamber Room
//   const [screenConfigLoading, setScreenConfigLoading] = useState(false)
//   const [optionsForScreenDeviceConfig, setOptionsForScreenDeviceConfig] = useState([])
//   const [optionsForVirtualConsultationDeviceConfig, setOptionsForVirtualConsultationDeviceConfig] =
//     useState([])
//   const [selectedScreenConfigForRemoteScreen, setSelectedScreenConfigForRemoteScreen] = useState(
//     roleCaConfig?.SCREEN_DEVICE_CONFIG_ID,
//   )
//   const [selectedCurrentVirtualRoomId, setSelectedCurrentVirtualRoomId] = useState(
//     roleCaConfig?.CURRENT_VIRTUAL_ROOM_ID,
//   )

//   // OOH - Brand, Location, Mentor
//   const [oohDataLoading, setOOHDataLoading] = useState(false)
//   const [selectedOptionsForBrand, setSelectedOptionsForBrand] = useState([])
//   const [selectedOptionsForLocation, setSelectedOptionsForLocation] = useState([])
//   const [selectedOptionsForMentor, setSelectedOptionsForMentor] = useState([])
//   const [selectedBrandForOOH, setSelectedBrandForOOH] = useState(roleCaConfig?.BRAND_FOR_OOH)
//   const [selectedLocationForOOH, setSelectedLocationForOOH] = useState(
//     roleCaConfig?.LOCATION_FOR_OOH,
//   )
//   const [selectedMentorForOOH, setSelectedMentorForOOH] = useState(roleCaConfig?.MENTOR_FOR_OOH)

//   async function intialSetupOOH() {
//     setOOHDataLoading(true)
//     // check for locally stored here only
//     const allAssociatedClinics = assistantData?.associatedClinicsData
//     const allClinicBrands = []
//     allAssociatedClinics?.forEach((clinicLoc) => {
//       if (allClinicBrands?.find((item) => item?.clinicBrandId === clinicLoc?.clinicBrandId)) {
//       } else {
//         allClinicBrands.push({
//           clinicBrandId: clinicLoc?.clinicBrandId,
//           clinicBrandName: clinicLoc?.clinicBrandName,
//         })
//       }
//     })
//     const allSupportRoles = []
//     assistantData?.clinicAssistantProfileData?.forEach((item) =>
//       allSupportRoles.push(...(item?.supportRoles || [])),
//     )
//     const allManagerProfiles = []
//     if (Array.isArray(allSupportRoles)) {
//       allSupportRoles?.forEach(async (supportRole) => {
//         const response = await getCPDataWithoutParams(
//           `/api/secure/clinic-assistant/service-provider?id=${
//             supportRole?.managerId
//           }&slug=&zoneOffset=${encodeURIComponent(
//             getTimezoneOffset(),
//           )}&appVersion=${appVersion}&platformType=${platformWeb}`,
//         )
//         if (response.status === 200) {
//           allManagerProfiles.push(response?.data)
//         }
//       })
//     }
//     setSelectedOptionsForBrand(allClinicBrands)
//     setSelectedOptionsForLocation(allAssociatedClinics)
//     setSelectedOptionsForMentor(allManagerProfiles)
//     setOOHDataLoading(false)
//   }

//   async function intialSetupDoctorScreen() {
//     setScreenConfigLoading(true)
//     setOptionsForScreenDeviceConfig(
//       assistantData?.associatedScreenDeviceConfigs?.screenDeviceConfigsList,
//     )
//     setOptionsForVirtualConsultationDeviceConfig(
//       assistantData?.associatedScreenDeviceConfigs?.virtualDeviceConfigsList,
//     )
//     setScreenConfigLoading(false)
//   }

//   function handleContinue(
//     selectedFlow,
//     selectedBrandForOOH,
//     selectedLocationForOOH,
//     selectedMentorForOOH,
//     selectedScreenConfigForRemoteScreen,
//     selectedCurrentVirtualRoomId,
//   ) {
//     // Update role configuration
//     const newRoleCaConfig = roleCaConfig ? { ...roleCaConfig } : {}
//     newRoleCaConfig.FLOW_ID = selectedFlow

//     // Prepare data based on selected flow
//     let additionalData = {}
//     let redirectUrl = ''

//     switch (selectedFlow) {
//       case ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN:
//         newRoleCaConfig.BRAND_FOR_OOH = selectedBrandForOOH
//         newRoleCaConfig.LOCATION_FOR_OOH = selectedLocationForOOH
//         newRoleCaConfig.MENTOR_FOR_OOH = selectedMentorForOOH

//         additionalData = {
//           clinicBrandId: selectedBrandForOOH,
//           clinicLocationId: selectedLocationForOOH,
//         }

//         redirectUrl = `${window.location.origin}/ca-home/${selectedBrandForOOH}/${selectedLocationForOOH}/counter-screen/${selectedMentorForOOH}`
//         break

//       case ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR:
//         newRoleCaConfig.SCREEN_DEVICE_CONFIG_ID = selectedScreenConfigForRemoteScreen
//         newRoleCaConfig.CURRENT_VIRTUAL_ROOM_ID = selectedCurrentVirtualRoomId

//         // Find clinic details for the selected virtual room
//         const selectedVirtualRoom = assistantData?.associatedChamberRoomsData?.find(
//           (room) => room?.id === selectedCurrentVirtualRoomId,
//         )
//         const clinicLocation = assistantData?.associatedClinicsData?.find(
//           (clinic) => clinic?.id === selectedVirtualRoom?.clinicLocationId,
//         )

//         additionalData = {
//           screenDeviceConfigId: selectedScreenConfigForRemoteScreen,
//           chamberRoomId: selectedCurrentVirtualRoomId,
//           clinicLocationId: selectedVirtualRoom?.clinicLocationId,
//           clinicBrandId: clinicLocation?.clinicBrandId,
//         }

//         redirectUrl = `${window.location.origin}/ca-home/chamber-screen-home`
//         break
//       default:
//         redirectUrl = `${window.location.origin}/ca-home`
//         break
//     }

//     // Save configuration
//     localStorage.setItem('ROLE_CA_CONFIG', JSON.stringify(newRoleCaConfig))

//     // Register screen and redirect
//     registerScreen(selectedFlow, additionalData)
//       .then((result) => {
//         if (result.success) {
//           console.log('Screen registered successfully:', result.screenId)
//           window.location.href = redirectUrl
//         } else {
//           console.error('Failed to register screen:', result.error)
//           // Still redirect even if registration fails
//           window.location.href = redirectUrl
//         }
//       })
//       .catch((error) => {
//         console.error('Error during screen registration:', error)
//         // Still redirect even if registration fails
//         window.location.href = redirectUrl
//       })
//   }

//   useEffect(() => {
//     intialSetupOOH()
//     intialSetupDoctorScreen()
//   }, [assistantData])

//   return (
//     <div>
//       {CAFlowDialogOpen && (
//         <Dialog
//           open={CAFlowDialogOpen}
//           PaperProps={{
//             sx: { padding: '24px', margin: '8px', maxWidth: '600px', borderRadius: '8px' },
//           }}
//         >
//           <CloseIcon
//             sx={{ position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' }}
//             onClick={() => setCAFlowDialogOpen(false)}
//           />
//           <div style={{ marginBottom: '24px' }}>
//             <div>
//               <b>What is this device being used as?</b>
//             </div>
//             <div style={{ fontSize: '12px' }}>
//               <b>(यह डिवाइस किस रूप में उपयोग की जा रही है?)</b>
//             </div>
//           </div>
//           <div className="d-flex flex-row justify-content-center gap-2">
//             <CAFlowSelectionDialogBox
//               IconComp={<TvIcon />}
//               mainText={'Appointment Number Screen'}
//               translatedMainText={'(अपॉइंटमेंट नंबर स्क्रीन)'}
//               subText={
//                 'Used for Appointment number display, and other information in patient waiting area'
//               }
//               translatedSubText={
//                 '(अपॉइंटमेंट नंबर डिस्प्ले और रोगी प्रतीक्षालय में अन्य जानकारी के लिए उपयोग किया जाता है)'
//               }
//               selected={selectedFlow === ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN}
//               clickFunction={() => setSelectedFlow(ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN)}
//             />
//             <CAFlowSelectionDialogBox
//               IconComp={<AppRegistrationIcon />}
//               mainText={'Reception Tablet / Laptop'}
//               translatedMainText={'(रिसेप्शन टैबलेट / लैपटॉप)'}
//               subText={'Used for bookings and patient management'}
//               translatedSubText={'(बुकिंग और रोगी प्रबंधन के लिए उपयोग किया जाता है)'}
//               selected={selectedFlow === ROLE_CA_FLOWS.FLOW_RECEPTION_TABLET}
//               clickFunction={() => setSelectedFlow(ROLE_CA_FLOWS.FLOW_RECEPTION_TABLET)}
//             />
//             <CAFlowSelectionDialogBox
//               IconComp={<PersonOutlineIcon />}
//               mainText={'Doctors / Therapists Video Screen'}
//               translatedMainText={'(डॉक्टर्स / थेरेपिस्ट्स वीडियो स्क्रीन)'}
//               subText={'Used by doctors/therapists to join in this clinic remotely on video'}
//               translatedSubText={
//                 '(डॉक्टर्स/थेरेपिस्ट्स द्वारा इस क्लिनिक में वीडियो के माध्यम से दूरस्थ रूप से शामिल होने के लिए उपयोग किया जाता है)'
//               }
//               selected={selectedFlow === ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR}
//               clickFunction={() => setSelectedFlow(ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR)}
//             />
//           </div>
//           {oohDataLoading ? (
//             <Spinner size="sm" variant="dark" />
//           ) : (
//             selectedFlow === ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN && (
//               <div className="d-flex flex-column gap-2 w-100" style={{ marginTop: '16px' }}>
//                 <div>Select a Clinic:</div>
//                 <Select
//                   labelId="brand-selector-ooh"
//                   id="brand-selector-ooh"
//                   value={selectedBrandForOOH}
//                   onChange={(e) => setSelectedBrandForOOH(e.target.value)}
//                 >
//                   {selectedOptionsForBrand?.map((item) => (
//                     <MenuItem key={item?.id} value={item?.clinicBrandId}>
//                       {item?.clinicBrandName}
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 <div>Select Clinic Location:</div>
//                 <Select
//                   labelId="location-selector-ooh"
//                   id="location-selector-ooh"
//                   value={selectedLocationForOOH}
//                   onChange={(e) => setSelectedLocationForOOH(e.target.value)}
//                 >
//                   {selectedOptionsForLocation?.map((item) => {
//                     if (item?.clinicBrandId !== selectedBrandForOOH) {
//                       return null
//                     }
//                     return (
//                       <MenuItem key={item?.id} value={item?.id}>
//                         {item?.name}
//                       </MenuItem>
//                     )
//                   })}
//                 </Select>
//                 <div>Select Doctor/Therapist:</div>
//                 <Select
//                   labelId="chamber-room-selector-ooh"
//                   id="chamber-room-selector-ooh"
//                   value={selectedMentorForOOH}
//                   onChange={(e) => setSelectedMentorForOOH(e.target.value)}
//                 >
//                   {selectedOptionsForMentor?.map((manager) => {
//                     const supportRoles =
//                       assistantData?.clinicAssistantProfileData?.find(
//                         (item) => item?.clinicId === selectedLocationForOOH,
//                       )?.supportRoles || []
//                     if (supportRoles?.some((item) => item?.managerId === manager?.id)) {
//                       return (
//                         <MenuItem key={manager?.id} value={manager?.id}>
//                           {manager?.name}
//                         </MenuItem>
//                       )
//                     } else {
//                       return null
//                     }
//                   })}
//                 </Select>
//               </div>
//             )
//           )}
//           {screenConfigLoading ? (
//             <Spinner variant="dark" size="sm" />
//           ) : (
//             selectedFlow === ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR && (
//               <div className="d-flex flex-column gap-2 w-100" style={{ marginTop: '16px' }}>
//                 <div>Select Screen Device Config:</div>
//                 <Select
//                   labelId="screen-device-config-selector"
//                   id="screen-device-config-selector"
//                   value={selectedScreenConfigForRemoteScreen}
//                   onChange={(e) => setSelectedScreenConfigForRemoteScreen(e.target.value)}
//                 >
//                   {optionsForScreenDeviceConfig?.map((item) => (
//                     <MenuItem key={item?.id} value={item?.id}>
//                       {item?.title}
//                     </MenuItem>
//                   ))}
//                 </Select>
//                 <div>Select Chamber Room:</div>
//                 <Select
//                   labelId="virtual-device-configs-list"
//                   id="virtual-device-configs-list"
//                   value={selectedCurrentVirtualRoomId}
//                   onChange={(e) => setSelectedCurrentVirtualRoomId(e.target.value)}
//                 >
//                   {optionsForVirtualConsultationDeviceConfig?.map((item) => {
//                     if (item?.screenDeviceConfigId !== selectedScreenConfigForRemoteScreen) {
//                       return null
//                     }
//                     return (
//                       <MenuItem key={item?.virtualChamberRoomId} value={item?.virtualChamberRoomId}>
//                         {getNameOfVirtualChamberRoom(item, assistantData)}
//                       </MenuItem>
//                     )
//                   })}
//                 </Select>
//               </div>
//             )
//           )}
//           <div className="w-100 d-flex justify-content-center">
//             <CAFlowSelectionDialogContinueButton
//               disabled={
//                 !(
//                   selectedFlow === ROLE_CA_FLOWS.FLOW_RECEPTION_TABLET ||
//                   (selectedFlow === ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN &&
//                     selectedBrandForOOH &&
//                     selectedLocationForOOH &&
//                     selectedMentorForOOH) ||
//                   (selectedFlow === ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR &&
//                     selectedScreenConfigForRemoteScreen &&
//                     selectedCurrentVirtualRoomId)
//                 )
//               }
//               onClick={() =>
//                 handleContinue(
//                   selectedFlow,
//                   selectedBrandForOOH,
//                   selectedLocationForOOH,
//                   selectedMentorForOOH,
//                   selectedScreenConfigForRemoteScreen,
//                   selectedCurrentVirtualRoomId,
//                 )
//               }
//             >
//               Continue
//             </CAFlowSelectionDialogContinueButton>
//           </div>
//         </Dialog>
//       )}
//     </div>
//   )
// }

export const CAFlowSelectionDialogBox = ({
  IconComp,
  mainText,
  subText,
  translatedMainText,
  translatedSubText,
  selected,
  clickFunction,
}) => {
  return (
    <div
      className="d-flex flex-column p-2 w-100"
      style={{
        border: '1px solid #cecece',
        borderRadius: '4px',
        width: '150px',
        cursor: 'pointer',
        background: selected ? '#7450AA' : '#fff',
        color: selected ? '#fff' : '#000',
      }}
      onClick={() => {
        if (clickFunction) {
          clickFunction()
        }
      }}
    >
      <div>{IconComp}</div>
      <div className="d-flex flex-column gap-2" style={{ minHeight: '130px' }}>
        <div style={{ fontSize: '16px', fontWeight: 500 }}>{mainText}</div>
        <div style={{ fontSize: '14px' }}>{translatedMainText}</div>
      </div>
      <div style={{ fontSize: '12px', marginTop: '16px' }}>{subText}</div>
      <div style={{ fontSize: '12px', marginTop: '8px' }}>{translatedSubText}</div>
    </div>
  )
}

export function getNameOfVirtualChamberRoom(virtualConsultationDevice, assistantData) {
  const clinicLocationId = (assistantData?.associatedChamberRoomsData || [])?.find(
    (item) => item?.id === virtualConsultationDevice?.virtualChamberRoomId,
  )?.clinicLocationId

  return `${
    (assistantData?.associatedChamberRoomsData || [])?.find(
      (item) => item?.id === virtualConsultationDevice?.virtualChamberRoomId,
    )?.title
  } (${
    (assistantData?.associatedClinicsData || [])?.find((item) => item?.id === clinicLocationId)
      ?.clinicBrandName
  })`
}

export function BrandLeftTreeItem({
  hideUpper = false,
  hideDown = false,
  hideCircle = false,
  circleChecked = false,
  circlePosition = 'center',
  noMargins,
}) {
  function circle() {
    return (
      <div className="d-flex align-items-center">
        {!hideCircle ? (
          <BrandLeftSideTreeCircle checked={circleChecked}>
            {circleChecked && <Check sx={{ color: 'white' }} />}
          </BrandLeftSideTreeCircle>
        ) : (
          <div className="d-flex justify-content-center" style={{ width: '30px' }}>
            <BrandVerticalSideTreeLine />
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{ marginRight: noMargins ? '0px' : '10px' }}
    >
      {circlePosition === 'start' && circle()}
      <BrandVerticalSideTreeLine style={{ opacity: hideUpper ? 0 : 1 }} />
      {circlePosition === 'center' && circle()}

      <BrandVerticalSideTreeLine style={{ opacity: hideDown ? 0 : 1 }} />
      {circlePosition === 'end' && circle()}
    </div>
  )
}
